define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    validation:{
      application:{
        required: true,
      }
    },
    urlRoot: '/delegate/civics-api/api/cdr/logs/{0}/',
    url: function() {
		    return this.urlRoot.format(this._dataType);
		},
  });
});
